export default __webpack_public_path__ + "static/media/100_38801.81eb46d4.jpg";